/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme } from "@nordcloud/gnui";

export function getMessage(messageComponent: string | JSX.Element) {
  return typeof messageComponent === "string" ? (
    <Text color={theme.color.text.text02}>{messageComponent}</Text>
  ) : (
    messageComponent
  );
}
